package com.dignicate.web.data.markdown.parser.handlers

import com.dignicate.web.data.markdown.model.UnorderedListItem

object InlineLinkParser {
    fun parseLinkOrText(itemText: String): UnorderedListItem {
        if (itemText.startsWith("[")) {
            val textEndIndex = itemText.indexOf("](")
            val urlEndIndex = itemText.lastIndexOf(")")
            if (textEndIndex != -1 && urlEndIndex != -1 && urlEndIndex > textEndIndex) {
                val text = itemText.substring(1, textEndIndex)
                val url = itemText.substring(textEndIndex + 2, urlEndIndex)
                return UnorderedListItem.Link(text, url)
            }
        }
        return UnorderedListItem.Text(itemText)
    }
}
